<template>
  <div class="position-relative">
    <div class="pt-0">
      <div class="mashup pt-5 pb-5">
        <b-container>
          <b-row align-v="start" class="">
            <b-col sm="12" md="12">
              <h2 class="mashup-h2 text-color-dark text-center pb-4">
                A mashup of practical knowledge & wild experience
              </h2>
            </b-col>
          </b-row>

          <b-row no-gutters align-v="start" class="position-relative">
            <b-col sm="12" md="6">
              <b-img
                class="p-md-3 d-block d-md-none"
                fluid
                src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1711638512/2024/53359355701_3620929dbb_k_1.png"
              ></b-img>
              <b-img
                class="d-none d-md-block mashup-img"
                src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1711638512/2024/53359355701_3620929dbb_k_1.png"
              ></b-img>
              <!-- Mobile text -->
              <div class="bg-white pb-3 d-block d-md-none">
                <h2 class="headlineMashUp pl-3 pt-4 pb-0 pb-sm-3 mt-0">
                  Connect
                </h2>
                <p class="paragraf p-3">
                  With a program that unites work and social activities, Øredev
                  is designed to drive the kinds of serendipitous encounters
                  conducive to creating collaborations, building communities,
                  and establishing friendships!
                </p>
              </div>
            </b-col>
            <b-col
              sm="12"
              md="6"
              class="bg-white d-flex d-flex align-items-center justify-content-center"
            >
              <div
                class="text-block d-none d-md-flex align-items-center justify-content-center"
              >
                <div class="p-5">
                  <h2 class="headlineMashUp pt-4 pl-3 pt-3 pb-0 pb-sm-3">
                    Connect
                  </h2>
                  <p class="paragraf p-3">
                    With a program that unites work and social activities,
                    Øredev is designed to drive the kinds of serendipitous
                    encounters conducive to creating collaborations, building
                    communities, and establishing friendships!
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row no-gutters align-v="start" class="position-relative">
            <b-col sm="12" md="6" class="bg-green">
              <b-img
                fluid
                class="d-block d-md-none"
                src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1711638512/2024/53331767838_156bba565f_k_1.png"
              ></b-img>

              <div
                class="text-block d-none d-md-flex align-items-center justify-content-center"
              >
                <div class="p-5">
                  <h2 class="headlineMashUp pl-3 pt-3 pb-0 pb-sm-3 text-light">
                    Explore
                  </h2>
                  <p class="paragraf p-3 pt-0 text-light">
                    Leave the distractions of your daily life behind, forget
                    about your screen, get energised by the change of scenery.
                    Get your mind fully immersed in the conference, open up and
                    let in new inspiration. Enjoy the diversity and get
                    invigorated by the mixing of minds and cultures and build
                    long lasting connections.
                  </p>
                </div>
              </div>
            </b-col>
            <b-col sm="12" md="6" class="bg-green">
              <div class="d-block d-md-none">
                <h2 class="headlineMashUp pl-3 pt-3 pb-0 pb-sm-3 text-light">
                  Explore
                </h2>
                <p class="paragraf p-3 pt-0 text-light">
                  Leave the distractions of your daily life behind, forget about
                  your screen, get energised by the change of scenery. Get your
                  mind fully immersed in the conference, open up and let in new
                  inspiration. Enjoy the diversity and get invigorated by the
                  mixing of minds and cultures and build long lasting
                  connections.
                </p>
              </div>

              <b-img
                class="d-none d-md-block mashup-img"
                fluid
                src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1711638512/2024/53331767838_156bba565f_k_1.png"
              ></b-img>
            </b-col>
          </b-row>

          <b-row no-gutters align-v="start" class="position-relative pb-5">
            <b-col sm="12" md="6" class="">
              <b-img
                class="p-md-3 d-block d-md-none"
                fluid
                src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1711638511/2024/53359355871_86488106c6_k_1.png"
              ></b-img>
              <b-img
                class="d-none d-md-block mashup-img"
                src="https://res.cloudinary.com/oredev/image/upload/q_auto/v1711638511/2024/53359355871_86488106c6_k_1.png"
              ></b-img>
              <!-- Mobile text -->
              <div class="bg-yellow pb-3 pt-2 d-block d-md-none">
                <h2 class="headlineMashUp pl-3 pt-3 pb-0 pb-sm-3">
                  Challenge yourself
                </h2>
                <p class="paragraf p-3">
                  Enjoy the conference atmosphere, get extensive learning
                  opportunities, jump into in-depth conversations during coffee
                  breaks, sessions, and exhibition floor catch-ups.
                </p>
              </div>
            </b-col>
            <b-col
              sm="12"
              md="6"
              class="bg-yellow d-flex align-items-center justify-content-center"
            >
              <div
                class="text-block d-none d-md-flex align-items-center justify-content-center"
              >
                <div class="p-5">
                  <h2 class="headlineMashUp pt-4 pl-3 pt-3 pb-0 pb-sm-3">
                    Challenge yourself
                  </h2>
                  <p class="paragraf p-3">
                    Enjoy the conference atmosphere, get extensive learning
                    opportunities, jump into in-depth conversations during
                    coffee breaks, sessions, and exhibition floor catch-ups.
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- Mobile figures start -->
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1712048064/2024/red-triangle.png"
      alt="triangle"
      class="position-absolute d-block d-sm-none"
      style="width: 80px; top: 42%; right: 2%"
    />
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1712048063/2024/Asset_6.png"
      alt="triangle"
      class="position-absolute d-block d-sm-none"
      style="width: 100px; top: 90%; right: 0%; z-index: 1"
    />
    <!-- Mobile figures end -->
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1712048064/2024/red-triangle.png"
      alt="triangle"
      class="position-absolute d-none d-xl-block"
      style="width: 200px; top: 25%; right: 2%"
    />
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1712048063/2024/Asset_6.png"
      alt="triangle"
      class="position-absolute d-none d-xl-block"
      style="width: 150px; top: 62%; right: 0%"
    />
    <img
      src="https://res.cloudinary.com/oredev/image/upload/v1712048063/2024/pink-triangle.png"
      alt="triangle"
      class="position-absolute d-none d-xl-block"
      style="width: 200px; top: 85%; left: 10%"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: true,
      isVisible: true,
      cardCaruselCounter: 1,
      rightClick: true,
    };
  },
  computed: {
    view1() {
      return "appCards" + this.cardCaruselCounter + "Top";
    },
    view2() {
      return "appCards" + this.cardCaruselCounter + "Bottom";
    },
  },

  methods: {
    arrowClickLeft() {
      if (this.cardCaruselCounter === 1) {
        this.cardCaruselCounter = 3;
        this.rightClick = false;
        return;
      }
      this.rightClick = false;
      this.cardCaruselCounter--;
    },
    arrowClickRight() {
      if (this.cardCaruselCounter === 3) {
        this.cardCaruselCounter = 1;
        this.rightClick = true;
        return;
      }
      this.rightClick = true;
      this.cardCaruselCounter++;
    },

    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
  },
};
</script>




<style lang="scss" scoped>
@import "../styles/variables.scss";

.mashup-h1 {
  font-size: 4rem;
  text-transform: none;
}

.mashup-h2 {
  text-transform: none;
  font-family: Outfit;
  font-size: 32px;
  font-weight: 500;
  line-height: 40.32px;
  letter-spacing: 0.05em;
  text-align: left;
  color: $text-color-light;
}

#cardsHeadline {
  margin-top: 10%;
}
.paragraf {
  color: $text-dark;
  min-width: 200px;
  max-width: 450px;
  word-break: break-word;
  text-align: left;

  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 24px;
  position: relative;
  z-index: 99;
}

.mashup {
  background-color: $bg-dark;
  top: -20px;
  color: $text-dark;

  min-width: 250px;
}
.mash-text-container {
  padding-left: 7rem;
  padding-right: 7rem;
}
.headlineMashUp {
  color: $text-dark;
  font-family: Outfit, Geneva, Tahoma, sans-serif;
  text-align: left;
  margin-top: 5%;
  margin-left: 0;
  text-transform: none;
  font-weight: 500;
  font-size: 26px;
  margin-bottom: 0;
}

.mashup-img {
  height: 451px;
  width: inherit;
  object-fit: cover;
}
.text-block {
  height: 451px;
}
</style>



// WEBPACK FOOTER //
// src/components/Mashup.vue